// removed by extract-text-webpack-plugin
module.exports = {"menu":"_3EjfP0XbmVFyhTeRnPFXeg_0","menu_item":"_1DJnIbKj65aoKsYfib4sN__0","menu_item__clickable":"_2JiMYn1HrBqsKiv6FPhxor_0","menu_item__unclickable":"_2JisNetVw9uWEmdra2R1V__0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15f63a44","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-contextmenujs/src/components/Contextmenu.vue
// module id = /dM2
// module chunks = 1